/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbServiceTutelleGridDto
 */
export interface FcbServiceTutelleGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbServiceTutelleGridDto
     */
    idserviceTutelle?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleGridDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleGridDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleGridDto
     */
    adresse?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleGridDto
     */
    codePostal?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleGridDto
     */
    localite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleGridDto
     */
    telephone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbServiceTutelleGridDto
     */
    fax?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbServiceTutelleGridDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbServiceTutelleGridDto interface.
 */
export function instanceOfFcbServiceTutelleGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbServiceTutelleGridDtoFromJSON(json: any): FcbServiceTutelleGridDto {
    return FcbServiceTutelleGridDtoFromJSONTyped(json, false);
}

export function FcbServiceTutelleGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbServiceTutelleGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idserviceTutelle': !exists(json, 'idserviceTutelle') ? undefined : json['idserviceTutelle'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'adresse': !exists(json, 'adresse') ? undefined : json['adresse'],
        'codePostal': !exists(json, 'codePostal') ? undefined : json['codePostal'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'telephone': !exists(json, 'telephone') ? undefined : json['telephone'],
        'fax': !exists(json, 'fax') ? undefined : json['fax'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbServiceTutelleGridDtoToJSON(value?: FcbServiceTutelleGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idserviceTutelle': value.idserviceTutelle,
        'code': value.code,
        'nom': value.nom,
        'adresse': value.adresse,
        'codePostal': value.codePostal,
        'localite': value.localite,
        'telephone': value.telephone,
        'fax': value.fax,
        'actif': value.actif,
    };
}

